import * as React from "react";
import { XlWidget } from "./xlwidget";
import { TextArea } from "../components/textarea";
import { FlexContainer } from "../grid/flexcontainer";
import { LoadingDimmer } from "./loadingdimmer";
import { css } from "emotion";
const textAreaClass = css({
    position: "relative",
    transition: "margin-bottom .5s",
    zIndex: 1,
});
const buttonContainerClass = css({
    maxWidth: "none!important",
    transition: "bottom .5s",
    bottom: "0px",
    right: 0,
    position: "absolute",
    zIndex: -1,
});
const textAreaEditModeClass = css({
    marginBottom: "50px",
});
const buttonContainerEditModeClass = css({
    maxWidth: "initial",
    bottom: "-50px",
});
export class TextAreaXlWidget extends XlWidget {
    constructor(props) {
        super(props, true);
        this.additionalWrapperClasses = [textAreaClass];
        this.additionalButtonContainerClasses = [buttonContainerClass];
        this.additionalEditModeClass = textAreaEditModeClass;
        this.additionalButtonContainerEditModeClass = buttonContainerEditModeClass;
        this.wrapperFlexProps = {
            direction: "col",
            overflow: "hidden",
        };
        this.buttonWrapperFlexProps = {
            direction: "row",
            "md-justify": "end",
            spaceBetween: "base",
        };
    }
    renderSaveIndicator() {
        return null;
    }
    renderInner() {
        return (React.createElement(FlexContainer, { direction: "col" },
            React.createElement(LoadingDimmer, { loading: this.isDirty() && this.props.saveInProgress },
                React.createElement(TextArea, { ref: (el) => (this.inputWrapper = el), rows: this.props.rows, disabled: this.props.saveInProgress || !!this.props.disabled, required: this.props.required, maxLength: this.props.maxLength, onKeyDown: this.handleKeyPress, onFocus: (e) => this.edit(), onValueChange: this.editValueUpdate, value: this.currentValue(), size: this.props.size }))));
    }
}
export default TextAreaXlWidget;
//# sourceMappingURL=textareaxlwidget.js.map